/*
 * search query parameter from current url
 *
 * @paramName key
 * @return
 *   paramName == false: object include all params
 *   paramName != false: value for input paramName
 */
function getCurUrlParameter (paramName) {
  if (!paramName) {
    const result = {}
    if (!window) return result
    const searchString = window.location.search.substring(1)
    const params = searchString.split('&')
    for (let i = 0; i < params.length; i++) {
      const val = params[i].split('=')
      result[val[0]] = val[1]
    }
    return result
  } else {
    if (!window) return null
    const searchString = window.location.search.substring(1)
    const params = searchString.split('&')
    for (let i = 0; i < params.length; i++) {
      const val = params[i].split('=')
      if (val[0] === paramName) {
        return val[1]
      }
    }
    return null
  }
}

function isInApp () {
  return (this.getQueryString(window.location.href, 'deviceId') || !!navigator.userAgent.match(/org\.geekbang\.GeekTime/i))
  // his.getQueryString(window.location.href, 'deviceId')
}

function getQueryString (link, key) {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const queryString = link.split('?').length > 1 ? link.split('?')[1] : ''
  const r = queryString.match(reg)
  if (r !== null) return decodeURIComponent(r[2])
  return ''
}
/**
   * CDN 的图片处理
   * @see https://help.aliyun.com/document_detail/44688.html?spm=a2c4g.11186623.6.1147.3b4d5b80nblRUg
   * @param {Url}     url               图片地址
   * @param {Object}  options           图片配置
   * @param {Object}  options.crop      裁剪图片
   * @param {Number}  options.crop.x    裁剪区的左上角 x 坐标
   * @param {Number}  options.crop.y    裁剪区的左上角 y 坐标
   * @param {Number}  options.crop.w    裁剪区宽度
   * @param {Number}  options.crop.h    裁剪区高度
   * @param {String}  options.crop.g    设置裁剪的原点位置 [nw,north,ne,west,center,east,sw,south,se]
   * @param {Object}  options.resize    缩放图片
   * @param {Number}  options.resize.w  缩放宽度
   * @param {Number}  options.resize.h  缩放高度
   * @param {Number}  options.resize.m  缩放高度
   * @param {Number}  options.resize.l  缩放高度
   * @param {Number}  options.resize.s  缩放高度
   * @param {Number}  options.resize.p  缩放百分比
   */
 function image (url, options = {}) {
  const extra = []
  const crop = []
  const resize = []

  // 裁剪参数
  if (options.crop) {
    options.crop.x && crop.push(`x_${options.crop.x}`)
    options.crop.y && crop.push(`y_${options.crop.y}`)
    options.crop.w && crop.push(`w_${options.crop.w}`)
    options.crop.h && crop.push(`h_${options.crop.h}`)
    options.crop.g && crop.push(`g_${options.crop.g}`)

    crop.length && extra.push(`crop,${crop.join(',')}`)
  }

    // 缩放参数
    if (options.resize) {
      options.resize.w && resize.push(`w_${options.resize.w}`)
      options.resize.h && resize.push(`h_${options.resize.h}`)
      options.resize.p && resize.push(`p_${options.resize.p}`)

      resize.length && extra.push(`resize,${resize.join(',')}`)
    }

    const oss = extra.length ? extra.join('/') : ''
    return `${url}${oss ? '?x-oss-process=image/' + oss : ''}`
  }

/**
 * 移动端打开遮罩层时使用，固定 body
 */
const fixedBody = (className => {
  var scrollTop = 0
  var bodyTop = 0

  return {
    open () {
      scrollTop =
        document.scrollingElement.scrollTop || document.body.scrollTop
      document.body.style.top = -scrollTop + 'px'
      document.body.classList.add(className)
      bodyTop = document.body.style.top
    },
    close () {
      document.body.classList.remove(className)
      document.scrollingElement.scrollTop = scrollTop
      document.body.scrollTop = scrollTop
      document.body.style.top = bodyTop
    }
  }
})('fixed')

export default {
  getCurUrlParameter,
  getQueryString,
  isInApp,
  image,
  fixedBody
}
